module.exports = __webpack_public_path__ + "static/media/valor1.c4839a84.png";